import { Box, Input, Separator, SimpleGrid } from "@chakra-ui/react";
import ProductForm from "@/core/products/components/ProductForm";
import type { Control, FieldValues } from "react-hook-form";
import { Controller } from "react-hook-form";

import type { LocalProductFormInput } from "../schemas/localProductSchema";
import ImageUpload from "@/ui/inputs/ImageUpload";
import { Field } from "@/ui/chakra/field";

interface LocalProductFormProps {
  control: Control<LocalProductFormInput>;
}

const LocalProductForm: React.FC<LocalProductFormProps> = ({ control }) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={4}>
      <SimpleGrid columns={{ base: 1, md: 2 }} gap={4}>
        <ProductForm control={control as unknown as Control<FieldValues>} />
      </SimpleGrid>

      <Separator />
      <SimpleGrid columns={{ base: 1, md: 2 }} gap={4}>
        <Controller
          control={control}
          name="code"
          render={({ field, fieldState: { invalid, error } }) => (
            <Field
              label="Codigo"
              required
              invalid={invalid}
              errorText={error?.message}
            >
              <Input type="text" placeholder="Codigo del producto" {...field} />
            </Field>
          )}
        />
        <Controller
          control={control}
          name="comment"
          render={({ field, fieldState: { invalid, error } }) => (
            <Field
              label="Comentario"
              invalid={invalid}
              errorText={error?.message}
            >
              <Input
                type="text"
                placeholder="Comentario del producto"
                {...field}
              />
            </Field>
          )}
        />
        <Controller
          control={control}
          name="purchasePrice"
          render={({ field, fieldState: { invalid, error } }) => (
            <Field
              label="Precio de compra"
              invalid={invalid}
              errorText={error?.message}
            >
              <Input type="number" placeholder="Precio de compra" {...field} />
            </Field>
          )}
        />
        <Controller
          control={control}
          name="maximumStock"
          render={({ field, fieldState: { invalid, error } }) => (
            <Field
              label="Stock máximo"
              invalid={invalid}
              errorText={error?.message}
            >
              <Input type="number" placeholder="Stock máximo" {...field} />
            </Field>
          )}
        />
      </SimpleGrid>

      <Separator />

      <Controller
        control={control}
        name="images"
        render={({ field }) => (
          <ImageUpload
            value={field.value ?? []}
            onChange={(files) => field.onChange(files)}
            maxFiles={1}
            maxSizeMB={5}
          />
        )}
      />
    </Box>
  );
};

export default LocalProductForm;
